import { Component, ElementRef, OnInit, ViewChild, HostListener } from "@angular/core";
import { DropDownList } from "../../models/DropDownList.model";
import { UserSearchModel } from "../../models/UserSearch.model";
import { UserService } from "../../services/user.service";
import { CommonHelper } from "../../shared/helpers/CommonHelper";
import { ErrorHandlerProvider } from "../../shared/providers/errorHandler.provider";
import { ToastsManager } from "ng2-toastr";
import { Json2csvService } from "../../services/json2csv.service";
import { User } from "../../models/User.model";
import { LocalStorage } from "../../shared/wrappers/LocalStorage";
import { Roles, RoleSearch } from "../../models/Roles.model";


@Component({
    selector: "app-users",
    templateUrl: "./users.component.html",
    styleUrls: ["./users.component.scss"]
})
export class UsersComponent implements OnInit {
    @ViewChild("buttonDeactiveUserModal") buttonDeactiveUserModal: ElementRef;
    loading: boolean = false;
    userSearchModel: UserSearchModel = new UserSearchModel();
    allUsers: User[] = [];
    loggedUser: User = new User();

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 0;
    currentPage: number = 1;

    dropDownRolesList: DropDownList[] = new Array<DropDownList>();
    selectedRoleItem: DropDownList[] = new Array<DropDownList>();
    dropDownRoleSettings = {}

    userBeingDeactivated: User = new User();

    usersExport: User[] = new Array<User>();
    roles: Roles[] = [];
    roleSearch: RoleSearch = new RoleSearch({});

    constructor(
        public commonHelper: CommonHelper,
        private userService: UserService,
        private errorHandler: ErrorHandlerProvider,
        private toastr: ToastsManager,
        private json2csv: Json2csvService,
        private localStorage: LocalStorage,
    ){};

    async ngOnInit(): Promise<void> {
        this.loading = true;

        this.roles = await this.userService.getRoles(this.roleSearch);
        this.dropDownRolesList = this.roles.map((role) => {
            return {
                id: role.type,
                itemName: role.name
            }
        })
        this.dropDownRoleSettings = this.commonHelper.getDropDownSettings(false, 'Cargos', true, 'Marcar todas os cargos', 'Desmarcar todos os cargos', true,null, '');
        this.loggedUser = this.localStorage.retrieve("user");
        await this.searchUsers(1);
        this.loading = false;
    };

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {

        if (event.keyCode === 13) {
            this.searchUsers(1);
        }
    }

    async searchUsers(page?: number, toexport?: boolean) {
        try {
            let limit, skip;
            this.loading = true;
            this.currentPage = page ? page : 1;
            this.userSearchModel.skip = (this.currentPage - 1) * this.userSearchModel.limit;

            this.userSearchModel.type = [];
            for (let role of this.selectedRoleItem) {
                this.userSearchModel.type.push(role.id);
            };

            if(toexport) {
                limit = this.userSearchModel.limit;
                skip = this.userSearchModel.skip;
                delete this.userSearchModel.skip;
                delete this.userSearchModel.limit;
            }

            let res = await this.userService.searchUsers(this.userSearchModel);
            this.allUsers = [...res.data];
            this.totalItems = res.totalItems;

            if (toexport) {
                this.userSearchModel.skip = skip;
                this.userSearchModel.limit = limit;
            }

            this.loading = false;
        } catch (error) {
            this.errorHandler.interceptError(error, 'Usuário');
            this.closeModal();
        };
    };

    async export() {
       await this.searchUsers(1, true);

        this.json2csv.export(
            this.allUsers.map(user => {
                return {
                    "Nome": user.name ? user.name : "-",
                    "E-mail": user.username ? user.username : "-",
                    "Cargo": user.type ? this.commonHelper.transcriptInternalRole(user.type) : "-"
                };
            }),
        `relatório de usuários financial - ${new Date().toLocaleDateString('pt-br')}`);
    };

    trimEmailForSearchUser(): void {
        this.userSearchModel.username = this.userSearchModel.username.trim().toLowerCase();
    };

    isActive(active: boolean): string {
        return active ? "badge-success" : "badge-danger";
    };

    isActiveText(active: boolean): string {
        return active ? "Ativo" : "Inativo";
    };

    deactiveUserModal(user: User) {
        this.userBeingDeactivated.loadUserDataForGrid(user);
        this.buttonDeactiveUserModal.nativeElement.click();
    };

    async closeModal() {
        this.userBeingDeactivated = new User();
        await this.searchUsers(1);
    };

    async updateUserStatus(): Promise<void> {
        try {
            this.loading = true;
            const response = await this.userService.update(this.userBeingDeactivated);
            this.loading = false;
            if (response._id) {
                this.toastr.success("Usuário atualizado com sucesso", "Módulo de Usuário");
            } else {
                this.errorHandler.interceptError(response, 'Usuário');
            }

            this.closeModal();
        } catch (error) {
            this.errorHandler.interceptError(error, 'Usuário');
            this.loading = false;
            this.closeModal();
        };
    };

    checkUserIC(user: User): boolean {
        const userFound = this.roles.find(role => role.type == user.type);
        if (userFound && userFound.systemic) return true;
        return false;
    }

    transcriptRole(roleType) {
        const userRole = this.roles.find(role => role.type == roleType as string);
        return userRole ? userRole.name : 'Cargo indefinido';
    }
}



// WEBPACK FOOTER //
// ./src/app/views/users/users.component.ts